module.exports = __webpack_public_path__ + "img/icon-other-house.15f5ab75.svg";